import React from 'react'
import { FilterGroup } from 'components/Filters/components/FilterModal'
import { CityAndStateFilter } from 'components/Filters/components/CityAndStateFilter'
import { ZipcodeFilter } from 'components/Filters/fields/ZipcodeFilter'
import { FilterStore } from 'components/Filters/FilterStore'
import { SelectFilterProps } from 'components/Filters/fields/SelectFilter'

type CommonLocationGroupProps = {
  filterStore: FilterStore
  stateSelectProps: Omit<SelectFilterProps, 'filterStore'>
  citySelectProps: Omit<SelectFilterProps, 'filterStore'>
  /** Override when the vertical's city column isn't `city` (e.g. K12 `lcity`). */
  cityKey?: string
  /** Override when the vertical's state column isn't `state` (e.g. `state_abbr`). */
  stateKey?: string
  /** Extra vertical-specific location filters appended after the zip filter. */
  children?: React.ReactNode
}

/**
 * The shared "Location" filter group (city + state + zip) every institutional
 * vertical filterset repeats. The city/state select props stay per-vertical
 * (column keys differ); the group structure lives here once.
 */
export function CommonFiltersetLocationGroup({
  filterStore,
  stateSelectProps,
  citySelectProps,
  cityKey,
  stateKey,
  children,
}: CommonLocationGroupProps) {
  return (
    <FilterGroup title="Location">
      <CityAndStateFilter
        filterStore={filterStore}
        stateSelectProps={stateSelectProps}
        citySelectProps={citySelectProps}
        cityKey={cityKey}
        stateKey={stateKey}
      />
      <ZipcodeFilter filterStore={filterStore} />
      {children}
    </FilterGroup>
  )
}
